module.exports = __webpack_public_path__ + "static/img/water_quality_ph.1bb4b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/water_quality_ph.png
// module id = ZDBG
// module chunks = 1